/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Addons } from './addons';
import { PlanTypeEnum } from './plan-type-enum';
import { RetrySettings } from './retry-settings';

/**
 *
 * @export
 * @interface CreatePropGoalDto
 */
export class CreatePropGoalDto {
    /**
     *
     * @type {PlanTypeEnum}
     * @memberof CreatePropGoalDto
     */
    type: PlanTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CreatePropGoalDto
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropGoalDto
     */
    templateName?: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropGoalDto
     */
    title: string;
    /**
     *
     * @type {Addons}
     * @memberof CreatePropGoalDto
     */
    addons?: Addons;
    /**
     *
     * @type {RetrySettings}
     * @memberof CreatePropGoalDto
     */
    retrySettings?: RetrySettings;
    /**
     *
     * @type {number}
     * @memberof CreatePropGoalDto
     */
    limitAccountsNum?: number;
    /**
     *
     * @type {number}
     * @memberof CreatePropGoalDto
     */
    maxFreeTrialLimit?: number;
    /**
     *
     * @type {boolean}
     * @memberof CreatePropGoalDto
     */
    active?: boolean;
    /**
     *
     * @type {number}
     * @memberof CreatePropGoalDto
     */
    positionId?: number;
}
